import { render, staticRenderFns } from "./ModuleIndex.vue?vue&type=template&id=c3b01cb6"
import script from "./ModuleIndex.vue?vue&type=script&lang=js"
export * from "./ModuleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports